// extracted by mini-css-extract-plugin
export default {"chip":"DifficultyLevel_chip__RIpzx","chip__0":"DifficultyLevel_chip__0__0vvP9","chip__1":"DifficultyLevel_chip__1__R6l2F","chip__2":"DifficultyLevel_chip__2__EOFJ4"};